export enum CookiesEnum {
    COMPANY = 'company',
    COMPANY_DATA = 'companyData',
    COMPANY_LANG = 'companyLang',
    TRAVELER_COMPANIONS = 'travelerCompanions',
    AUTO_SCORING_2024 = 'autoScoring2024',
    CAPACITY = 'capacity',
    WIYP_2024 = 'wiyp2024',
    WEBSITE = 'website'
}